import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchTwilioDetails,
  fetchUserTwilioDetails,
  createTwilio,
  updateTwilioDetails,
  deleteTwilioDetails,
  fetchTwilioPhoneNumbers,
} from "./twilioAPI";

export const getTwilioDetails = createAsyncThunk(
  "twilio/getAll",
  async (accountId, { rejectWithValue }) => {
    try {
      const result = await fetchTwilioDetails(accountId);
      return result;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch Twilio config"
      );
    }
  }
);

export const getUserTwilioDetails = createAsyncThunk(
  "twilio/getUser",
  async (uuid, { rejectWithValue }) => {
    try {
      return await fetchUserTwilioDetails(uuid);
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch Twilio config"
      );
    }
  }
);

export const saveTwilioDetail = createAsyncThunk(
  "twilio/save",
  async ({ uuid, config }, { rejectWithValue }) => {
    try {
      if (uuid) {
        return await updateTwilioDetails(uuid, config);
      } else {
        return await createTwilio(config);
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to save Twilio config"
      );
    }
  }
);

export const removeTwilioDetails = createAsyncThunk(
  "twilio/remove",
  async (uuid, { rejectWithValue }) => {
    try {
      await deleteTwilioDetails(uuid);
      return uuid;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getAllTwilioPhoneNumbers = createAsyncThunk(
  "twilio/getAllPhoneNumbers",
  async (config, { rejectWithValue }) => {
    try {
      const result = await fetchTwilioPhoneNumbers(config);
      return result;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch Twilio phone numbers"
      );
    }
  }
);  

const TwilioSlice = createSlice({
  name: "twilio",
  initialState: {
    twilio: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTwilioDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTwilioDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.twilio = Array.isArray(action.payload)
          ? action.payload
          : [action.payload];
      })

      .addCase(getTwilioDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(saveTwilioDetail.fulfilled, (state, action) => {
        state.twilio = [action.payload];
      })

      .addCase(removeTwilioDetails.fulfilled, (state, action) => {
        state.twilio = state.twilio.filter((c) => c.uuid !== action.payload);
      })

      .addCase(getAllTwilioPhoneNumbers.fulfilled, (state, action) => {
        state.loading = false;
        state.twilio = action.payload;
      })

      .addCase(getAllTwilioPhoneNumbers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default TwilioSlice.reducer;
